<section class="common__spacing--between-section">
  <div class="container-fluid">
    <div class="feature-section_heading text-align-center">
      <h2 class="secondary__heading">{{ content.title }}</h2>
    </div>
  </div>
</section>

<section class="staticContent">
  <div class="container-fluid static">
    <iframe #contentFrame></iframe>
  </div>
</section>
